var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTerms = function SvgTerms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 328,
    height: 488,
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0,0,0)",
      contentVisibility: "visible"
    },
    viewBox: "0 0 628 788"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "terms_svg__d",
    x1: 731.367,
    x2: 1021.402,
    y1: 429.506,
    y2: 481.123,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E94A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#E04545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D73F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "terms_svg__e",
    x1: 623.493,
    x2: 1050.938,
    y1: 424.204,
    y2: 437.459,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E94A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#E04545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D73F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "terms_svg__f",
    x1: 619.906,
    x2: 735.728,
    y1: 345.752,
    y2: -870.885,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E94A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#E04545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D73F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "terms_svg__c",
    x1: 600.5,
    x2: 524.177,
    y1: 578.699,
    y2: 911.221,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#428DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#2F80EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1D72D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "terms_svg__b",
    x1: 621.149,
    x2: 833.326,
    y1: 543.983,
    y2: 624.881,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#428DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#2F80EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1D72D8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "terms_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h628v788H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#terms_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7931E",
    d: "M-11.021-10.826c5.094-5.055 26.51-17.858 26.51-17.858s9.954 9.753 14.921 17.243Q17.34-2.613 4.269 6.214c-14.645 9.89-18.018 12.363-33.708 22.47-2.673-3.254-.04-14.312 10.601-25.814 2.351-2.541 5.359-11.257 7.817-13.696",
    style: {
      display: "block"
    },
    transform: "matrix(2 0 0 2 556.598 721.732)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBB03B",
    d: "M1.342-11.063c7.053-1.349 31.971-.004 31.971-.004s2.799 13.646 2.729 22.631l-31.552.043c-17.676.023-21.856.191-40.52-.191-.398-4.192 7.971-11.891 23.229-15.487 3.368-.795 10.739-6.342 14.143-6.992",
    style: {
      display: "block"
    },
    transform: "matrix(2 0 0 2 455.322 755.973)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A4F",
    d: "M332.647 149.513c-4.858-6.53-12.861-11.067-16.648-18.277-2.548-4.844-2.254-9.611-2.513-15.085-.567-11.809-5.691-23.345-14.084-31.682-6.237-6.202-14.448-11.046-17.759-19.187a21.3 21.3 0 0 1-1.316-4.816v-.014c-.511-3.528-6.699-9.128-20.72-9.128-8.071 0-15.323 3.598-15.239 5.761v.007c.651 5.404 2.373 12.831 4.515 17.507 6.559 14.322 11.081 26.103 19.502 39.417 5.397 8.533 11.2 22.4 16.779 30.814 10.948 16.52 26.532 28.583 32.958 47.33 5.37-5.79 25.989-17.426 25.989-17.426s-2.4-13.034-11.464-25.22m-87.292-90.202",
    style: {
      display: "block"
    },
    transform: "matrix(2 0 0 2 -99.182 318.202)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A4F",
    d: "M20.422 7.64q-3.705 17.735-7.42 35.47c-1.211 5.796-2.394 11.907-1.561 17.661l.042.244v.014c-.049 2.121-10.92 4.306-18.97 4.306-8.064 0-16.247-3.025-16.989-7.68v-.007q-.061-.535-.112-1.05c-.497-5.054.574-10.122 1.638-15.092q4.401-20.643 8.813-41.285c2.121-9.919 4.249-19.979 3.64-30.108-.252-4.095-.945-8.196-.574-12.284.777-8.687 6.181-16.171 11.396-23.164 13.153 4.438 21.462 18.06 23.625 31.759 2.17 13.699-.686 27.636-3.528 41.216",
    style: {
      display: "block"
    },
    transform: "rotate(-.221 82284.077 -113284.047)scale(2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBEB6",
    d: "M11.226 8.006c-.84.595-2.422 7.308-3.402 6.118C6.445 12.451-.828 2.448-2.151 1.888A6.86 6.86 0 0 1-4.643.075c-.469-.532-.994-1.127-1.568-1.547a3.2 3.2 0 0 0-.854-.427h-.021c-1.155-.357-1.855-1.071-2.135-2.037-.238-.826-.364-1.967.196-2.401-.189-1.68-.84-2.772-1.834-3.605.028.028.07.049.105.063-.042-.028-.091-.049-.126-.084-.014 0-.021-.014-.035-.021-.553-.518-.294-2.058.189-2.898.49-.847 2.275-1.666 2.926-1.288.777.455 1.232 1.288 1.68 2.072 2.065 3.654 4.235 5.516 7.14 8.554C2.112-2.41 10.043 6.984 11.226 8.006",
    style: {
      display: "block"
    },
    transform: "matrix(2 0 0 2 165.817 156.816)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72D8",
    d: "M-21.45.079C-10.726 10.964-.035 18.091 7.344 24.433c3.295-15.463 5.41-28.365 5.733-44.172.102-5.018.066-10.386 2.851-14.563s9.661-5.951 12.754-1.997c1.976 2.526 1.591 6.102 1.107 9.271L27.018-8.867C24.814 5.578 22.592 20.1 18.041 33.985c-.453 1.383-1.01 2.866-2.242 3.644-.691.437-1.519.596-2.327.714-5.049.738-7.924-1.134-12.702-2.921-10.681-3.994-13.061-7.133-19.499-16.538-3.513-5.131-10.678-8.793-11.45-11.781.789-.274 5.959-6.439 8.729-7.024",
    style: {
      display: "block"
    },
    transform: "matrix(2 0 0 2 215.301 162.553)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2A19C",
    d: "M251.514 110.969c-3.14-6.484-7.526-9.036-11.546-15.018-1.588-2.368-4.228-5.206-6.552-6.858-5.084-3.61-11.736-2.304-17.934-1.602 6.608-6.04 15.092-22.032 19.346-29.906 2.416 6.04 6.964 10.672 10.434 14.544 5.616 6.268 13.09 10.51 20.42 14.644-4.66 1.508-8.04 5.658-10.034 10.13-1.99 4.468-2.842 9.346-4.134 14.066"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E94A47",
    d: "M440.394 171.771c-6.348 0-45.346-21.75-45.346-21.75l-25.846 46.67 34.916 24.014z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#terms_svg__b)",
    d: "M-40.641-37.844c2.155-1.095.176-3.244 18.855.243 30.064 5.612 29.59 17.026 37.184 22.656 7.028 5.21 7.259 5.951 12.017 7.703C36.031-4.07 37.618-2.936 46.007.008c-9.729 17.565-8.272 19.904-12.63 39.501-10.386-7.135-14.84-11.203-21.422-16.866-5.01-4.31-.196-1.376-19.531-11.913-6.858-3.737-28.909-18.888-33.255-25.375-6.6-9.852-7.262-19.409.19-23.199",
    transform: "matrix(2 0 0 2 327.978 156.347)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m318.228 177.769-5.018-2.744 2.75-5.012 5.018 2.744zM347.642 192.855l-5.018-2.744 2.75-5.012 5.018 2.744z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#23286B",
    d: "M536.141 547.852c1.928 11.782-4.73 45.958-3.884 57.868.58 8.164 1.51 33.844 3.368 41.816 6.782 33.94 2.868 58.929-14.51 88.81-23.58 0-40.81 1.812-64.392-.906 19.554-64.706-5.393-195.305-20.47-275.494-11.28-60.488 3.014-101.062-9.884-192.1-.934-2.286 30.354-30.38 22.984-27.342-10.508 4.33-15.088 11.712-24.376 18.258-4.082-9.97-24.488-40.778-24.488-40.778l30.836-48.938s13.14 3.758 20.406 6.802c42.17 17.672 55.816 44.938 61.22 83.82 13.784 99.202-4.492 167.448-1.294 193.028 6.35 50.75 16.322 45.314 24.484 95.156"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M484.811 293.896c.164-.386.066-.792-.318-.956s-.794-.066-.958.318c-.164.386-.066.79.318.954s.794.066.958-.316m18.94-67.394c.406-.098.572-.482.476-.888-.098-.406-.482-.57-.888-.472s-.572.482-.476.888c-.048.526.48.57.888.472m-16.726 6.29c.406-.098.57-.482.474-.888s-.482-.572-.888-.474-.57.482-.474.888c-.026.264.48.574.888.474m14.71 31.88a1.19 1.19 0 0 0-.722-.856 1.2 1.2 0 0 0-.858.724c.098.406.342.692.604.714.646.186.934-.058.976-.582m-17.994-.716a1.19 1.19 0 0 0-.724-.856q-.61.148-.858.722c.098.406.344.694.606.716.646.186 1.076-.176.976-.582m-5.316-63.062c.286-.242.328-.77.088-1.054-.24-.286-.766-.328-1.052-.088-.286.242-.33.768-.088 1.052.238.288.766.332 1.052.09m-13.236 12.156c.286-.242.328-.77.088-1.054-.24-.286-.766-.328-1.052-.088-.286.242-.33.768-.09 1.052.238.288.768.332 1.054.09m35.35 69.03c.022-.264-.198-.81-.606-.714-.264-.022-.812.198-.714.604-.022.264.196.81.604.714.384.164.672-.076.716-.604m-15.896-1.996c.022-.264-.196-.812-.604-.716-.264-.022-.672.078-.714.604-.022.264.076.67.604.716.406-.1.692-.342.714-.604m-1.528-62.346c.286-.242.452-.626.208-.912-.24-.286-.504-.31-.912-.208-.286.242-.452.626-.208.912.242.284.626.45.912.208m-12.632 9.686c.286-.242.452-.626.208-.912-.24-.286-.504-.308-.912-.206-.286.242-.452.626-.208.912.242.282.626.446.912.206m20.124 24.374c.406-.098.57-.482.474-.888-.098-.406-.482-.572-.888-.474s-.57.482-.474.888c.094.406.48.574.888.474m25.482 23.76c.406-.098.57-.482.474-.888-.098-.406-.482-.57-.888-.472s-.57.482-.474.888c.096.41.48.574.888.472m-17.79 4.742c.406-.098.57-.482.474-.888-.098-.406-.482-.572-.888-.474s-.57.482-.474.888c.098.408.48.576.888.474m-17.812 5.006c.406-.098.57-.482.474-.888-.098-.406-.482-.572-.888-.474s-.57.482-.474.888c.238.286.624.452.888.474m-11.39-71.398c.164-.386.066-.79-.318-.954s-.792-.068-.956.316c-.164.386-.066.792.318.956.242.286.792.068.956-.318m4.394 96.148q.792.064.858-.724m18.304-62.934c.286-.242.33-.77.09-1.054-.24-.286-.77-.328-1.054-.088-.286.242-.33.768-.09 1.052.24.286.768.332 1.054.09m9.97 7.734c.286-.242.33-.768.09-1.052-.24-.286-.768-.33-1.054-.09-.286.242-.45.626-.088 1.052.238.288.764.332 1.052.09m-14.972 10.684c.286-.242.33-.77.09-1.054-.24-.286-.628-.45-1.054-.088-.286.242-.33.768-.232 1.174.384.164.912.208 1.196-.032m3.386 32.384c.406-.098.57-.482.474-.888-.098-.406-.482-.572-1.01-.616-.406.098-.572.482-.618 1.01q.542.643 1.154.494m-6.778-3.088c.286-.242.31-.506.33-.768-.24-.286-.506-.308-.768-.328-.286.242-.31.506-.33.768.24.284.626.448.768.328"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#F2A19C",
    d: "M5.562-1.659C4.726-3.005 3.17-3.703 1.673-4.226c-3.226-1.125-6.607-1.782-10.01-2.077-.465-.04-.998-.05-1.321.286-.313.324-.29.87-.055 1.253.235.384.635.635 1.039.836 1.851.915 3.985 1.005 6.049 1.079l5.658.201a70 70 0 0 0-10.13.702c-1.42.203-3.026.582-3.7 1.847C-9.404.998-7.417.757-5.668.46-2.463-.083.742-.731 3.963-1.172c1.001-.138 2.283-.444 3.27-.447.739-.003 3.036 1.996 3.24 1.901.997-.461-.722.908.275.447C9.668-.306 7.901.255 6.539.874L-4.418 5.851c-.544.247-1.114.499-1.711.469s-1.22-.442-1.273-1.037l2.695-1.275L5.781-.957",
    style: {
      display: "block"
    },
    transform: "matrix(2 0 0 2 125.521 143.846)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2A19C",
    d: "M81.208 202.345c-.784.444-1.828-.066-2.28-.842-.454-.776-.472-1.724-.478-2.624-.05-7.31 1.194-13.604 1.144-20.914-.008-1.33.96-4.476 2.268-4.23 1.308 9.964 1.038 17.458 2.87 27.34-1.002-9.31-1.862-16.066-.082-25.26.254-1.32.622-2.72 1.64-3.598 3.42 4.26 3.682 10.166 3.65 15.626s-.104 11.292 2.856 15.882c-4.284 2.882-10.722 1.868-13.914-2.188-.42 3.144 2.744-2.334 2.326.808"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBEB6",
    d: "M77.176 181.441c-1.814-10.42-1.904-11.578-10.884-15.102 3.434 8.276 4.198 16.636 3.438 25.564-.176 2.098-.47 4.26.164 6.266.478 1.51 3.162 3.604 4.108 4.872 2.604 3.486 7.236 9.37 8.162 9.062 4.082-1.36 30.252-1.904 32.648-1.812 18.986.714 13.706 2.62 32.568 4.9a16.16 16.16 0 0 1-.444-11.296 163.4 163.4 0 0 1-39.652-8.81 63.2 63.2 0 0 1-23.36 6.96c-.388-3.566-5.86-4.828-6.444-8.368-.22-1.324-.076-10.922-.304-12.236"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBEB6",
    d: "M102.324 205.679c.644-2.198.21-4.354-.84-6.426-.056-.098-.112-.196-.14-.28-.56-1.232-.014-2.548 2.59-4.55 2.898-2.24 5.544-2.408 6.482-1.988 4.76 2.086 9.982 3.122 15.162 3.864 2.058.294 4.228.588 5.866 1.862 2.716 2.128 2.968 6.104 2.772 9.548s-.476 7.266 1.68 9.968z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#E94A47",
    d: "m66.139 139.6-9.672 5.136-15.266-8.156 44.136 65.55 9.222-4.832 6.65-4.53 46.252-24.17-53.81-63.736z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D7D8",
    d: "m65.269 143.078 34.16 45.006-13.638 6.342-43.198-60.412z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M98.789-63.826 82.633-87.461l16.552-17.612 20.237 28.107z",
    style: {
      display: "block"
    },
    transform: "matrix(2 0 0 2 -100 318)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M-2.238 20.623-18.394-3.011l16.551-17.612L18.394 7.483z",
    style: {
      display: "block"
    },
    transform: "matrix(2 0 0 2 102.056 149.101)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBEB6",
    d: "m6.551 1.343-.133-.042c-.028 0-.049-.014-.077-.021-.931-.231-1.981-.119-2.947.042a38 38 0 0 0-6.398 1.652c-1.008.35-2.17.322-3.213.119-1.05-.196-1.897-.854-1.519-1.848C-7.54.72-7.05.37-6.567.083-3.235-1.933 1.49-1.968 4.591-3.095c.42-.336 2.282-.168 2.926 1.232.42.903.665 3.234-.966 3.206",
    style: {
      display: "block"
    },
    transform: "rotate(.918 -9797.778 8729.46)scale(2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBEB6",
    d: "M9.889 3.136C9.028 4.382 7.215 5.005 6.585 4.48c-.014 0-.021-.014-.035-.021l-.007-.007c-.917-.749-2.128-1.288-3.549-1.862C.285 1.498-3.068.714-5.91.021c-2.835-.693-6.104-5.628-3.185-4.529C-2.788-2.135.586-.553 7.313-.203c.805.042 1.652.077 2.352.476.651.378.777 2.058.224 2.863",
    style: {
      display: "block"
    },
    transform: "matrix(2 0 0 2 130.889 135.93)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBEB6",
    d: "M7.603 6.041c-1.043.735-2.996 1.19-3.276.707a1 1 0 0 1-.07-.14q-.128-.22-.266-.441c-.014-.028-.035-.049-.049-.077C2.647 4.109.295 2.331-1.476.938c-3.115-2.457-3.052-2.324-6.615-4.76-.742-.504-1.113-1.477-.742-2.296.462-1.001 1.659-.924 2.59-.651C-.223-4.998 1.8-.511 7.26 2.576q.745.418 1.533.763c.511.231-.084 1.925-1.19 2.702",
    style: {
      display: "block"
    },
    transform: "matrix(2 0 0 2 92.829 185.757)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#terms_svg__c)",
    d: "M-36.822 27.065c8.131 3.209 15.434 6.613 23.566 9.821 2.548 1.005 5.981 1.828 8.717 1.973 6.752.357 10.374-.472 14.58-1.974 2.3-3.428 14.174-18.316 20.163-37.995 1.646-5.412 9.678-19.652 5.356-31.298-3.358-9.048-9.738-6.811-12.497-4.379-2.553 2.252-5.313 19.203-7.141 25.136C10.729 5.214 3.142 19.79 1.965 20.944c-1.917-.191-8.28-1.745-9.825-1.902l-25.322-2.583z",
    style: {
      display: "block"
    },
    transform: "matrix(2 0 0 2 193.133 162.345)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#E94A47",
    d: "M325.052 39.8c-7.893.345-15.873-2.802-21.405-8.438-2.132-2.172-3.992-4.749-6.719-6.107-7.109-3.539-14.775 2.832-21.605 6.88-17.441 10.331-41.713 6.637-54.102-8.31 2.562-12.188 17.35-20.124 28.936-15.527 8.743 3.469 14.94 12.516 24.234 13.972 12.672 1.988 23.174-11.018 35.968-11.925 17.474-1.234 30.987 20.09 48.337 17.667 3.99-.555 7.714-2.377 11.694-3.005 9.283-1.465 19.178 4.615 22.06 13.554 6.668-3.54 33.912-10.535 33.912-10.535s.843 14.583-.138 18.3c-2.133 8.088-4.475 8.456-.559 15.85-5.487 4.207-13.238-.944-17.46-6.417-4.219-5.473-9.04-12.295-15.936-11.78-3.96.294-7.385 3.108-11.34 3.465-7.829.704-13.027-7.866-20.138-11.21-11.033-5.189-23.555 3.033-35.739 3.566"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E94A47",
    d: "M420.441 69.952c-5.37-.4-11.398-.848-18.134-10.173-1.506-2.088-2.34-4.91-3.148-7.638-.889-3.004-1.806-6.116-3.59-8.016-.307-.328-.616-.887-.98-1.537-.157-.281-.384-.691-.565-.975a.908.908 0 0 1-.803-1.209c.156-.44.502-.724.926-.759.827-.055 1.29.73 2.028 2.06.237.428.562 1.014.717 1.177 2.078 2.213 3.06 5.532 4.007 8.74.799 2.699 1.553 5.252 2.88 7.09 6.24 8.639 11.58 9.038 16.744 9.423z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#23286B",
    d: "m282.935 16.824 11.525 5.64-5.646 11.516-11.522-5.639zM351.253 23.242l11.522 5.637-5.643 11.519-11.525-5.64zM390.581 32.41l11.525 5.64-5.646 11.517-11.523-5.64z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBEB6",
    d: "M204.246 95.139c6.917-1.017 18.17-3.812 22.158-9.553 5.386-7.752 9.516-18.93 10.297-28.332s-7.67-18.355-15.107-24.169c-5.454-4.264-12.47-5.859-19.235-7.338-3.785.385-7.373 2.435-9.626 5.5-1.997 2.716-6.784 9.059-6.802 12.428-.087 17.68-9.7 27.646-8.73 30.51 5.128 4.699 4.629 3.604 9.759 8.301 3.384 3.102 5.16 14.432 17.286 12.653"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#E94A47",
    d: "M180.44 52.726c38-8.686 31.97 35.103 56.763 11.885 9.867-29.907-10.35-40.609-26.343-42.235-2.392-.243-6.912-1.147-12.803.869-4.713 1.61-9.496 5.632-11.069 7.505-4.116 4.898-6.299 16.175-6.549 21.976"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#E94A47",
    d: "M206.257 176.2a.96.96 0 0 1-.924-.522.96.96 0 0 1 .422-1.293c.228-.118.26-.814-.081-1.783l-4.1-11.607c-.536-1.513-1.14-3.228-1.085-5.036.069-2.322 1.212-4.404 2.275-6.172a198 198 0 0 1 2.25-3.623c3.893-6.162 7.919-12.537 7.352-19.495-.327-4.029-2.147-7.684-4.073-11.552-1.973-3.964-4.016-8.065-4.285-12.595-.261-4.346 1.144-8.481 2.504-12.484.695-2.048 1.411-4.164 1.887-6.257 3.239-14.332-6.252-30.679-20.308-34.985a.961.961 0 0 1 .565-1.838c15.226 4.663 25.128 21.72 21.622 37.247-.495 2.193-1.23 4.357-1.94 6.45-1.36 4.004-2.643 7.783-2.406 11.752.25 4.137 2.111 7.887 4.087 11.853 1.922 3.862 3.908 7.855 4.267 12.25.622 7.598-3.577 14.248-7.641 20.678-.759 1.202-1.512 2.392-2.227 3.585-.936 1.56-1.945 3.381-2.001 5.241-.044 1.447.474 2.917.976 4.338l4.101 11.603c.692 1.96.368 3.505-.864 4.136a.9.9 0 0 1-.373.11"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#E94A47",
    d: "M226.276 143.728a.964.964 0 0 1-.954-1.332c3.053-7.28 6-15.606 2.33-22.255-.711-1.28-1.63-2.427-2.607-3.64-1.164-1.442-2.364-2.934-3.185-4.689-2.247-4.809-1.088-10.033.032-15.085.85-3.824 1.726-7.776 1.09-11.466-.693-4.02-3.187-7.621-5.676-10.97-6.009-8.08-7.646-15.284-9.379-22.91-1.086-4.777-2.21-9.725-4.457-15.347a.96.96 0 0 1 .538-1.25.96.96 0 0 1 1.252.537c2.305 5.765 3.444 10.783 4.547 15.636 1.76 7.748 3.279 14.433 9.045 22.188 2.632 3.534 5.26 7.359 6.03 11.79.705 4.062-.216 8.206-1.103 12.211-1.099 4.956-2.14 9.638-.168 13.854.72 1.544 1.8 2.882 2.938 4.299.985 1.222 2.005 2.49 2.792 3.918 4.084 7.402.985 16.23-2.241 23.926a.98.98 0 0 1-.824.585"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#23286B",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    d: "M191.218 56.067c-1.914 4.69-7.843 7.28-12.588 5.5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#23286B",
    d: "m218.842 14.367 11.649 5.377-5.382 11.641-11.65-5.375z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#terms_svg__d)",
    d: "M20.185 128.894h-5.782l-34.588-257.048h13.21v-.74z",
    transform: "matrix(2 0 0 2 307.43 518.712)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#terms_svg__e)",
    d: "m20.185-128.264-34.588 257.048h-5.782L6.936-128.784v.52z",
    transform: "matrix(2 0 0 2 47.968 518.932)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#terms_svg__f)",
    d: "M-57.911-5.875H57.911v11.75H-57.911z",
    transform: "matrix(2 0 0 2 177.668 250.65)"
  })))));
};
export default SvgTerms;